// store/constants.js
export const constants = {
    state: {
        cleaningCost: 350,
        pricePerNight: 485,
        poolHeatingPrice: 45,
        intermediateCleaningPrice: 65,
    },
    getters: {
        getCleaningCost: state => state.cleaningCost,
        getPricePerNight: state => state.pricePerNight,
        getPoolHeatingPrice: state => state.poolHeatingPrice,
        getIntermediateCleaningPrice: state => state.intermediateCleaningPrice,
    },
};
